import api from "../api/axios";

async function getRoles() {
  const response = await api.get(`/api/v1/roles`);
  if (!response) {
    throw new Error(response.statusText);
  }

  return response;
}

async function createRole(data) {
  const response = await api.post("/api/v1/roles", data);
  if (!response) {
    throw new Error(response.statusText);
  }

  return response;
}

async function updateRole(roleId, data) {
  return await api.put(`api/v1/roles/${roleId}`, data); 
};


export { getRoles, createRole, updateRole };
